import React from 'react';
import { Box } from '@mui/material';
import { SearchField ,Button} from '@getgo/chameleon-web-react-wrapper';
import { FormattedMessage,useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import st from 'core/shared-translations';
import classes from './clientlist.scss';

const ClientSearchBarView = ({ onChange,searchValue,onSearch,fullWidth}) => {
  const intl = useIntl();
  return (
    <Box className={classes["adminSearch"]}>
      <SearchField
        id="search-input"
        name="client"
        type="text"
        placeholder={intl.formatMessage(st['shared.search.client-id'])}
        label=""
        onChange={onChange}
        value={searchValue}
        style={{paddingRight: "10px"}}
        fullwidth={fullWidth}
      />
      <Button
        id="btn-search"
        variant="neutral"
        disabled={false}
        onClick={onSearch}
        title={intl.formatMessage(st['shared.search'])}
        aria-label={intl.formatMessage(st['shared.search'])}
      >
        <FormattedMessage {...st['shared.search']} />
      </Button>
    </Box>
  );
};

ClientSearchBarView.propTypes = {
  onChange: PropTypes.func.isRequired,
  searchValue: PropTypes.string.isRequired,
  error: PropTypes.object.isRequired,
  onSearch: PropTypes.func.isRequired,
  fullWidth: PropTypes.bool,
};

export default ClientSearchBarView;
